export default "__VITE_ASSET__CrtKXytZ__"